import React from 'react';
import ReactDOM from 'react-dom';
import GOTUtil from '../utils/GOTUtil';
import GOT from '../utils/GOT';
import QueryUtil from '../utils/QueryUtil';
import FormItemUtil from '../utils/FormItemUtil';
import {UserSetTreeLabelChangedStore} from '../stores/UserSetStores';
import UserSetActions from '../actions/UserSetActions';

export default class UserSetFormTree extends React.Component
{

	constructor(props){
		super(props);
		this.currentTreeNodeId = "";
		this.unscribeUserSetTreeLabelChangedStore = UserSetTreeLabelChangedStore.listen(this.onUserSetTreeLabelChanged.bind(this));    	
	}

	onUserSetTreeLabelChanged(label)
	{
		let treeObj = $.fn.zTree.getZTreeObj("UserSetFormTree");
		var nodes = treeObj.getSelectedNodes();
		if (nodes.length>0) {
			nodes[0].label = label;
			treeObj.updateNode(nodes[0]);
		}
	}

	componentDidMount(){
		var formXML = window.formModuleInstance.props.xml;
		var formLabel = window.formModuleInstance.formLabel;
		var setting = {
			data: 
			{
				key: {
					title:"title",
					children:"FormItem",
					name:"label"
				}
			},
			edit:
			{
				drag : {
				autoExpandTrigger : false,
				isCopy : false,
				isMove : true,
				prev : true,
				next : true,
				inner : true,
				borderMax : 1000,
				borderMin : 1000,
				minMoveSize : 5,
				maxShowNodeNum : 5,
				autoOpenTime : 500
				},
				editNameSelectAll : false,
				enable : true,
				showRemoveBtn : false,
				showRenameBtn : false
				
			},
			callback:
			{
				onClick: this.onItemClick.bind(this),
				onDblClick: this.onItemDblClick.bind(this),
				beforeDrop: this.zTreeBeforeDrop.bind(this)
			}
		};
		var _formXML = JSON.parse(JSON.stringify(formXML));
		var formDesign = _formXML.FormDesign;
		this.userSetForm = _formXML;
		formDesign.label = formLabel;
		formDesign.open = true;formDesign.pId = 0;formDesign.type = "FormDesign";
		//var zNodes=[{ id:formDesign.id, pId:0,formItemName:formDesign.name,name:formLabel,open:true,sourceNode:formDesign}];
		this.currentTreeNodeId = formDesign.id;
		this.getZNodes(formDesign);
		$.fn.zTree.init($(this.treeDiv), setting, formDesign);
		let treeObj = $.fn.zTree.getZTreeObj("UserSetFormTree");
		let treeNode = treeObj.getNodeByParam("id", formDesign.id);
		treeObj.selectNode(treeNode);

		let stateObj = {};
		stateObj.label = treeNode.name;stateObj.labelEnabled = false;
		stateObj.visible = true;stateObj.visibleEnabled = false;
		stateObj.allowEdit = true;stateObj.allowEditEnabled = false;
		stateObj.hideInVisible = true;stateObj.hideInVisibleEnabled = false;
		stateObj.skipTab = false;stateObj.skipTabEnabled = false;
		stateObj.width = "";stateObj.widthEnabled = false;
		stateObj.height = "";stateObj.heightEnabled = false;
		stateObj.shortCut = "";stateObj.shortCutEnabled = false;
		stateObj.displayLength = "";stateObj.displayLengthEnabled = false;
		stateObj.lockedNum = "";stateObj.lockedNumEnabled = false;
		stateObj.layout = "";stateObj.layoutEnabled = false;
		UserSetActions.userSetFormTreeChanged(stateObj);
	}

	getParentNode(node)
	{
		let treeObj = $.fn.zTree.getZTreeObj("UserSetFormTree");
		let nodes = treeObj.getNodes();
		nodes = treeObj.transformToArray(nodes);
		if (nodes.length>0)
			return treeObj.getNodeByParam("id",node.pId);
		return null;
	}

	validateLevel(items)
	{
		if(!items || items.length == 0)
			return true;
		var base = items[0];
		for(let i = 0;i<items.length;i++)
		{
			let item = items[i];
			if(item.pId != base.pId)
				return false;
		}
		return true;
	}

	validateFieldGroupDrag(base)
	{
		if(base.type != "FieldGroup")
			return true;
		
		let fieldGroupValue = GOTUtil.getPropertyValue(base,"FieldGroup")
		let componentValue = GOTUtil.getPropertyValue(base,"Component");
		let dataSourceValue = GOTUtil.getPropertyValue(base,"DataSource");
		
		
		if( 
			(dataSourceValue && componentValue) || 
			(dataSourceValue && fieldGroupValue)||
			componentValue	
		)
		{
			
			return false;
		}
		else
		{
			return true;
		}
		
	}

	getPosition(parent, from, to)
	{
		if(parent.indexOf("Editor")!=-1 
			||parent == "Button"
			||parent == "MenuItemButton"
			||parent == "Plugin"
			)
			return "false";
		
		if(parent == "Tab" && from != "TabPage")
			return "false"
		//对于parent为Tab的情况 并没有列出 并且只能是TabPage 而这里只能填哪些不行 所以单独判断
		var str = from + "->" + parent;
		switch(str)
		{
			case 'TabPage->Design':
			case 'FieldGroup->FieldGroup':
			case 'Button->FieldGroup':
			case 'MenuItemButton->FieldGroup':
			case 'ButtonGroup->FieldGroup':
			case 'ButtonMenu->FieldGroup':
			case 'DataGrid->FieldGroup':
			case 'Group->FieldGroup':
			case 'DividedBox->FieldGroup':
			case 'Tab->FieldGroup':
			case 'TabPage->FieldGroup':
			case 'StringEditor->ButtonGroup':
			case 'LongEditor->ButtonGroup':
			case 'DecimalEditor->ButtonGroup':
			case 'DateEditor->ButtonGroup':
			case 'TimeEditor->ButtonGroup':
			case 'BooleanEditor->ButtonGroup':
			case 'EnumEditor->ButtonGroup':
			case 'FieldGroup->ButtonGroup':
			case 'ButtonGroup->ButtonGroup':
			case 'DataGrid->ButtonGroup':
			case 'Group->ButtonGroup':
			case 'DividedBox->ButtonGroup':
			case 'Tab->ButtonGroup':
			case 'TabPage->ButtonGroup':
			case 'StringEditor->ButtonMenu':
			case 'LongEditor->ButtonMenu':
			case 'DecimalEditor->ButtonMenu':
			case 'DateEditor->ButtonMenu':
			case 'TimeEditor->ButtonMenu':
			case 'BooleanEditor->ButtonMenu':
			case 'EnumEditor->ButtonMenu':
			case 'FieldGroup->ButtonMenu':
			case 'ButtonGroup->ButtonMenu':
			case 'ButtonMenu->ButtonMenu':
			case 'DataGrid->ButtonMenu':
			case 'Group->ButtonMenu':
			case 'DividedBox->ButtonMenu':
			case 'Tab->ButtonMenu':
			case 'TabPage->ButtonMenu':
			case 'Button->DataGrid':
			case 'MenuItemButton->DataGrid':
			case 'ButtonGroup->DataGrid':
			case 'ButtonMenu->DataGrid':
			case 'DataGrid->DataGrid':
			case 'Group->DataGrid':
			case 'DividedBox->DataGrid':
			case 'Tab->DataGrid':
			case 'TabPage->DataGrid':
			case 'TabPage->Group':
			case 'TabPage->DividedBox':
			case 'TabPage->TabPage':
			case 'TabPage->Plugin':
				return "false";
		}
		
		
		str = from + "->" + to;
		
		switch(str)
		{
			case 'StringEditor->StringEditor' :  return 'true';
			case 'StringEditor->LongEditor' :  return 'true';
			case 'StringEditor->DecimalEditor' :  return 'true';
			case 'StringEditor->DateEditor' :  return 'true';
			case 'StringEditor->TimeEditor' :  return 'true';
			case 'StringEditor->BooleanEditor' :  return 'true';
			case 'StringEditor->EnumEditor' :  return 'true';
			case 'StringEditor->FieldGroup' :  return 'down';
			case 'StringEditor->Button' :  return 'true';
			case 'StringEditor->MenuItemButton' :  return 'true';
			case 'StringEditor->ButtonGroup' :  return 'true';
			case 'StringEditor->ButtonMenu' :  return 'true';
			case 'StringEditor->DataGrid' :  return 'down';
			case 'StringEditor->Group' :  return 'down';
			case 'StringEditor->DividedBox' :  return 'down';
			case 'StringEditor->Tab' :  return 'true';
			case 'StringEditor->TabPage' :  return 'down';
			case 'StringEditor->FormDesign' :  return 'down';
			case 'LongEditor->StringEditor' :  return 'true';
			case 'LongEditor->LongEditor' :  return 'true';
			case 'LongEditor->DecimalEditor' :  return 'true';
			case 'LongEditor->DateEditor' :  return 'true';
			case 'LongEditor->TimeEditor' :  return 'true';
			case 'LongEditor->BooleanEditor' :  return 'true';
			case 'LongEditor->EnumEditor' :  return 'true';
			case 'LongEditor->FieldGroup' :  return 'down';
			case 'LongEditor->Button' :  return 'true';
			case 'LongEditor->MenuItemButton' :  return 'true';
			case 'LongEditor->ButtonGroup' :  return 'true';
			case 'LongEditor->ButtonMenu' :  return 'true';
			case 'LongEditor->DataGrid' :  return 'down';
			case 'LongEditor->Group' :  return 'down';
			case 'LongEditor->DividedBox' :  return 'down';
			case 'LongEditor->Tab' :  return 'true';
			case 'LongEditor->TabPage' :  return 'down';
			case 'LongEditor->FormDesign' :  return 'down';
			case 'DecimalEditor->StringEditor' :  return 'true';
			case 'DecimalEditor->LongEditor' :  return 'true';
			case 'DecimalEditor->DecimalEditor' :  return 'true';
			case 'DecimalEditor->DateEditor' :  return 'true';
			case 'DecimalEditor->TimeEditor' :  return 'true';
			case 'DecimalEditor->BooleanEditor' :  return 'true';
			case 'DecimalEditor->EnumEditor' :  return 'true';
			case 'DecimalEditor->FieldGroup' :  return 'down';
			case 'DecimalEditor->Button' :  return 'true';
			case 'DecimalEditor->MenuItemButton' :  return 'true';
			case 'DecimalEditor->ButtonGroup' :  return 'true';
			case 'DecimalEditor->ButtonMenu' :  return 'true';
			case 'DecimalEditor->DataGrid' :  return 'down';
			case 'DecimalEditor->Group' :  return 'down';
			case 'DecimalEditor->DividedBox' :  return 'down';
			case 'DecimalEditor->Tab' :  return 'true';
			case 'DecimalEditor->TabPage' :  return 'down';
			case 'DecimalEditor->FormDesign' :  return 'down';
			case 'DateEditor->StringEditor' :  return 'true';
			case 'DateEditor->LongEditor' :  return 'true';
			case 'DateEditor->DecimalEditor' :  return 'true';
			case 'DateEditor->DateEditor' :  return 'true';
			case 'DateEditor->TimeEditor' :  return 'true';
			case 'DateEditor->BooleanEditor' :  return 'true';
			case 'DateEditor->EnumEditor' :  return 'true';
			case 'DateEditor->FieldGroup' :  return 'down';
			case 'DateEditor->Button' :  return 'true';
			case 'DateEditor->MenuItemButton' :  return 'true';
			case 'DateEditor->ButtonGroup' :  return 'true';
			case 'DateEditor->ButtonMenu' :  return 'true';
			case 'DateEditor->DataGrid' :  return 'down';
			case 'DateEditor->Group' :  return 'down';
			case 'DateEditor->DividedBox' :  return 'down';
			case 'DateEditor->Tab' :  return 'true';
			case 'DateEditor->TabPage' :  return 'down';
			case 'DateEditor->FormDesign' :  return 'down';
			case 'TimeEditor->StringEditor' :  return 'true';
			case 'TimeEditor->LongEditor' :  return 'true';
			case 'TimeEditor->DecimalEditor' :  return 'true';
			case 'TimeEditor->DateEditor' :  return 'true';
			case 'TimeEditor->TimeEditor' :  return 'true';
			case 'TimeEditor->BooleanEditor' :  return 'true';
			case 'TimeEditor->EnumEditor' :  return 'true';
			case 'TimeEditor->FieldGroup' :  return 'down';
			case 'TimeEditor->Button' :  return 'true';
			case 'TimeEditor->MenuItemButton' :  return 'true';
			case 'TimeEditor->ButtonGroup' :  return 'true';
			case 'TimeEditor->ButtonMenu' :  return 'true';
			case 'TimeEditor->DataGrid' :  return 'down';
			case 'TimeEditor->Group' :  return 'down';
			case 'TimeEditor->DividedBox' :  return 'down';
			case 'TimeEditor->Tab' :  return 'true';
			case 'TimeEditor->TabPage' :  return 'down';
			case 'TimeEditor->FormDesign' :  return 'down';
			case 'BooleanEditor->StringEditor' :  return 'true';
			case 'BooleanEditor->LongEditor' :  return 'true';
			case 'BooleanEditor->DecimalEditor' :  return 'true';
			case 'BooleanEditor->DateEditor' :  return 'true';
			case 'BooleanEditor->TimeEditor' :  return 'true';
			case 'BooleanEditor->BooleanEditor' :  return 'true';
			case 'BooleanEditor->EnumEditor' :  return 'true';
			case 'BooleanEditor->FieldGroup' :  return 'down';
			case 'BooleanEditor->Button' :  return 'true';
			case 'BooleanEditor->MenuItemButton' :  return 'true';
			case 'BooleanEditor->ButtonGroup' :  return 'true';
			case 'BooleanEditor->ButtonMenu' :  return 'true';
			case 'BooleanEditor->DataGrid' :  return 'down';
			case 'BooleanEditor->Group' :  return 'down';
			case 'BooleanEditor->DividedBox' :  return 'down';
			case 'BooleanEditor->Tab' :  return 'true';
			case 'BooleanEditor->TabPage' :  return 'down';
			case 'BooleanEditor->FormDesign' :  return 'down';
			case 'EnumEditor->StringEditor' :  return 'true';
			case 'EnumEditor->LongEditor' :  return 'true';
			case 'EnumEditor->DecimalEditor' :  return 'true';
			case 'EnumEditor->DateEditor' :  return 'true';
			case 'EnumEditor->TimeEditor' :  return 'true';
			case 'EnumEditor->BooleanEditor' :  return 'true';
			case 'EnumEditor->EnumEditor' :  return 'true';
			case 'EnumEditor->FieldGroup' :  return 'down';
			case 'EnumEditor->Button' :  return 'true';
			case 'EnumEditor->MenuItemButton' :  return 'true';
			case 'EnumEditor->ButtonGroup' :  return 'true';
			case 'EnumEditor->ButtonMenu' :  return 'true';
			case 'EnumEditor->DataGrid' :  return 'down';
			case 'EnumEditor->Group' :  return 'down';
			case 'EnumEditor->DividedBox' :  return 'down';
			case 'EnumEditor->Tab' :  return 'true';
			case 'EnumEditor->TabPage' :  return 'down';
			case 'EnumEditor->FormDesign' :  return 'down';
			case 'FieldGroup->StringEditor' :  return 'true';
			case 'FieldGroup->LongEditor' :  return 'true';
			case 'FieldGroup->DecimalEditor' :  return 'true';
			case 'FieldGroup->DateEditor' :  return 'true';
			case 'FieldGroup->TimeEditor' :  return 'true';
			case 'FieldGroup->BooleanEditor' :  return 'true';
			case 'FieldGroup->EnumEditor' :  return 'true';
			case 'FieldGroup->FieldGroup' :  return 'true';
			case 'FieldGroup->Button' :  return 'true';
			case 'FieldGroup->MenuItemButton' :  return 'true';
			case 'FieldGroup->ButtonGroup' :  return 'true';
			case 'FieldGroup->ButtonMenu' :  return 'true';
			case 'FieldGroup->DataGrid' :  return 'down';
			case 'FieldGroup->Group' :  return 'down';
			case 'FieldGroup->DividedBox' :  return 'down';
			case 'FieldGroup->Tab' :  return 'true';
			case 'FieldGroup->TabPage' :  return 'down';
			case 'FieldGroup->FormDesign' :  return 'down';
			case 'Button->StringEditor' :  return 'true';
			case 'Button->LongEditor' :  return 'true';
			case 'Button->DecimalEditor' :  return 'true';
			case 'Button->DateEditor' :  return 'true';
			case 'Button->TimeEditor' :  return 'true';
			case 'Button->BooleanEditor' :  return 'true';
			case 'Button->EnumEditor' :  return 'true';
			case 'Button->FieldGroup' :  return 'true';
			case 'Button->Button' :  return 'true';
			case 'Button->MenuItemButton' :  return 'true';
			case 'Button->ButtonGroup' :  return 'down';
			case 'Button->ButtonMenu' :  return 'down';
			case 'Button->DataGrid' :  return 'true';
			case 'Button->Group' :  return 'down';
			case 'Button->DividedBox' :  return 'down';
			case 'Button->Tab' :  return 'true';
			case 'Button->TabPage' :  return 'down';
			case 'Button->FormDesign' :  return 'down';
			case 'MenuItemButton->StringEditor' :  return 'true';
			case 'MenuItemButton->LongEditor' :  return 'true';
			case 'MenuItemButton->DecimalEditor' :  return 'true';
			case 'MenuItemButton->DateEditor' :  return 'true';
			case 'MenuItemButton->TimeEditor' :  return 'true';
			case 'MenuItemButton->BooleanEditor' :  return 'true';
			case 'MenuItemButton->EnumEditor' :  return 'true';
			case 'MenuItemButton->FieldGroup' :  return 'true';
			case 'MenuItemButton->Button' :  return 'true';
			case 'MenuItemButton->MenuItemButton' :  return 'true';
			case 'MenuItemButton->ButtonGroup' :  return 'down';
			case 'MenuItemButton->ButtonMenu' :  return 'down';
			case 'MenuItemButton->DataGrid' :  return 'true';
			case 'MenuItemButton->Group' :  return 'down';
			case 'MenuItemButton->DividedBox' :  return 'down';
			case 'MenuItemButton->Tab' :  return 'true';
			case 'MenuItemButton->TabPage' :  return 'down';
			case 'MenuItemButton->FormDesign' :  return 'down';
			case 'ButtonGroup->StringEditor' :  return 'true';
			case 'ButtonGroup->LongEditor' :  return 'true';
			case 'ButtonGroup->DecimalEditor' :  return 'true';
			case 'ButtonGroup->DateEditor' :  return 'true';
			case 'ButtonGroup->TimeEditor' :  return 'true';
			case 'ButtonGroup->BooleanEditor' :  return 'true';
			case 'ButtonGroup->EnumEditor' :  return 'true';
			case 'ButtonGroup->FieldGroup' :  return 'true';
			case 'ButtonGroup->Button' :  return 'true';
			case 'ButtonGroup->MenuItemButton' :  return 'true';
			case 'ButtonGroup->ButtonGroup' :  return 'true';
			case 'ButtonGroup->ButtonMenu' :  return 'true';
			case 'ButtonGroup->DataGrid' :  return 'true';
			case 'ButtonGroup->Group' :  return 'down';
			case 'ButtonGroup->DividedBox' :  return 'down';
			case 'ButtonGroup->Tab' :  return 'true';
			case 'ButtonGroup->TabPage' :  return 'down';
			case 'ButtonGroup->FormDesign' :  return 'down';
			case 'ButtonMenu->StringEditor' :  return 'true';
			case 'ButtonMenu->LongEditor' :  return 'true';
			case 'ButtonMenu->DecimalEditor' :  return 'true';
			case 'ButtonMenu->DateEditor' :  return 'true';
			case 'ButtonMenu->TimeEditor' :  return 'true';
			case 'ButtonMenu->BooleanEditor' :  return 'true';
			case 'ButtonMenu->EnumEditor' :  return 'true';
			case 'ButtonMenu->FieldGroup' :  return 'true';
			case 'ButtonMenu->Button' :  return 'true';
			case 'ButtonMenu->MenuItemButton' :  return 'true';
			case 'ButtonMenu->ButtonGroup' :  return 'down';
			case 'ButtonMenu->ButtonMenu' :  return 'true';
			case 'ButtonMenu->DataGrid' :  return 'true';
			case 'ButtonMenu->Group' :  return 'down';
			case 'ButtonMenu->DividedBox' :  return 'down';
			case 'ButtonMenu->Tab' :  return 'true';
			case 'ButtonMenu->TabPage' :  return 'down';
			case 'ButtonMenu->FormDesign' :  return 'down';
			case 'DataGrid->StringEditor' :  return 'true';
			case 'DataGrid->LongEditor' :  return 'true';
			case 'DataGrid->DecimalEditor' :  return 'true';
			case 'DataGrid->DateEditor' :  return 'true';
			case 'DataGrid->TimeEditor' :  return 'true';
			case 'DataGrid->BooleanEditor' :  return 'true';
			case 'DataGrid->EnumEditor' :  return 'true';
			case 'DataGrid->FieldGroup' :  return 'true';
			case 'DataGrid->Button' :  return 'true';
			case 'DataGrid->MenuItemButton' :  return 'true';
			case 'DataGrid->ButtonGroup' :  return 'true';
			case 'DataGrid->ButtonMenu' :  return 'true';
			case 'DataGrid->DataGrid' :  return 'true';
			case 'DataGrid->Group' :  return 'down';
			case 'DataGrid->DividedBox' :  return 'down';
			case 'DataGrid->Tab' :  return 'true';
			case 'DataGrid->TabPage' :  return 'down';
			case 'DataGrid->FormDesign' :  return 'down';
			case 'Group->StringEditor' :  return 'true';
			case 'Group->LongEditor' :  return 'true';
			case 'Group->DecimalEditor' :  return 'true';
			case 'Group->DateEditor' :  return 'true';
			case 'Group->TimeEditor' :  return 'true';
			case 'Group->BooleanEditor' :  return 'true';
			case 'Group->EnumEditor' :  return 'true';
			case 'Group->FieldGroup' :  return 'true';
			case 'Group->Button' :  return 'true';
			case 'Group->MenuItemButton' :  return 'true';
			case 'Group->ButtonGroup' :  return 'true';
			case 'Group->ButtonMenu' :  return 'true';
			case 'Group->DataGrid' :  return 'true';
			case 'Group->Group' :  return 'true';
			case 'Group->DividedBox' :  return 'down';
			case 'Group->Tab' :  return 'true';
			case 'Group->TabPage' :  return 'down';
			case 'Group->FormDesign' :  return 'down';
			case 'DividedBox->StringEditor' :  return 'true';
			case 'DividedBox->LongEditor' :  return 'true';
			case 'DividedBox->DecimalEditor' :  return 'true';
			case 'DividedBox->DateEditor' :  return 'true';
			case 'DividedBox->TimeEditor' :  return 'true';
			case 'DividedBox->BooleanEditor' :  return 'true';
			case 'DividedBox->EnumEditor' :  return 'true';
			case 'DividedBox->FieldGroup' :  return 'true';
			case 'DividedBox->Button' :  return 'true';
			case 'DividedBox->MenuItemButton' :  return 'true';
			case 'DividedBox->ButtonGroup' :  return 'true';
			case 'DividedBox->ButtonMenu' :  return 'true';
			case 'DividedBox->DataGrid' :  return 'true';
			case 'DividedBox->Group' :  return 'down';
			case 'DividedBox->DividedBox' :  return 'true';
			case 'DividedBox->Tab' :  return 'true';
			case 'DividedBox->TabPage' :  return 'down';
			case 'DividedBox->FormDesign' :  return 'down';
			case 'Tab->StringEditor' :  return 'true';
			case 'Tab->LongEditor' :  return 'true';
			case 'Tab->DecimalEditor' :  return 'true';
			case 'Tab->DateEditor' :  return 'true';
			case 'Tab->TimeEditor' :  return 'true';
			case 'Tab->BooleanEditor' :  return 'true';
			case 'Tab->EnumEditor' :  return 'true';
			case 'Tab->FieldGroup' :  return 'true';
			case 'Tab->Button' :  return 'true';
			case 'Tab->MenuItemButton' :  return 'true';
			case 'Tab->ButtonGroup' :  return 'true';
			case 'Tab->ButtonMenu' :  return 'true';
			case 'Tab->DataGrid' :  return 'true';
			case 'Tab->Group' :  return 'down';
			case 'Tab->DividedBox' :  return 'down';
			case 'Tab->Tab' :  return 'true';
			case 'Tab->TabPage' :  return 'down';
			case 'Tab->FormDesign' :  return 'down';
			case 'TabPage->StringEditor' :  return 'false';
			case 'TabPage->LongEditor' :  return 'false';
			case 'TabPage->DecimalEditor' :  return 'false';
			case 'TabPage->DateEditor' :  return 'false';
			case 'TabPage->TimeEditor' :  return 'false';
			case 'TabPage->BooleanEditor' :  return 'false';
			case 'TabPage->EnumEditor' :  return 'false';
			case 'TabPage->FieldGroup' :  return 'false';
			case 'TabPage->Button' :  return 'false';
			case 'TabPage->MenuItemButton' :  return 'false';
			case 'TabPage->ButtonGroup' :  return 'false';
			case 'TabPage->ButtonMenu' :  return 'false';
			case 'TabPage->DataGrid' :  return 'false';
			case 'TabPage->Group' :  return 'false';
			case 'TabPage->DividedBox' :  return 'false';
			case 'TabPage->Tab' :  return 'down';
			case 'TabPage->TabPage' :  return 'true';
			case 'TabPage->FormDesign' :  return 'false';
			case 'TabPage->Plugin': return 'false';
				
			default :
				return "true";
		}
		
		return "true";
	}

	validateType(items,toType,toParentType)
	{
		if(items.length == 0)
			return "draginvalid";
		var base = items[0];
		var basePosition = this.getPosition(toParentType,base.type,toType);
		for(let i = 0;i<items.length;i++)
		{
			let item = items[i];
			if(item != base)
			{
				if(this.getPosition(toParentType,base.type,toType) != basePosition)
					return "draginvalid";
			}
		}
		
		return basePosition;
	}

	getOrigItemById(id)
	{
		let formDesign = this.userSetForm.FormDesign;
		return this.getOrigItemByIdLoop(formDesign,id);
	}

	getOrigItemByIdLoop(formItem,id)
	{
		if(formItem.id == id)
			return formItem;
		for(let i = 0;i<formItem.FormItem.length;i++)
		{
			let childFormItem = formItem.FormItem[i];
			if(childFormItem.id == id)
				return childFormItem;
			let result = this.getOrigItemByIdLoop(childFormItem,id);
			if(result)
				return result;
		}
		return null;
	}

	deleteSrcItem(src,parent)
	{
		let _index = parent.FormItem.indexOf(src);
		parent.FormItem.splice(_index, 1);
	}

	adjustSrcForm(srcItems,targetNode,type)
	{
		for(let i = 0;i<srcItems.length;i++)
		{
			let srcItem = srcItems[i];
			let srcId = srcItem.id;
			let origSrcItem = this.getOrigItemById(srcId);
			let srcPid = origSrcItem.pId;
			let origSrcParent = this.getOrigItemById(srcPid);
			this.deleteSrcItem(origSrcItem,origSrcParent);

			let targetId = targetNode.id;
			let targetOrigItem = this.getOrigItemById(targetId);
			if(type == "inner")
			{
				if(!targetOrigItem.FormItem)
					targetOrigItem.FormItem = [];
				targetOrigItem.FormItem.push(origSrcItem);
				origSrcItem.pId = targetOrigItem.id;
			}
			else if(type == "next")
			{
				let targetPid = targetOrigItem.pId;
				let targetOrigParent = this.getOrigItemById(targetPid)
				let _index = targetOrigParent.FormItem.indexOf(targetOrigItem);
				_index++;
				targetOrigParent.FormItem.splice(_index, 0, origSrcItem);
				origSrcItem.pId = targetOrigParent.id;
			}
			else if(type == "prev")
			{
				let targetPid = targetOrigItem.pId;
				let targetOrigParent = this.getOrigItemById(targetPid)
				let _index = targetOrigParent.FormItem.indexOf(targetOrigItem);
				targetOrigParent.FormItem.splice(_index, 0, origSrcItem);
				origSrcItem.pId = targetOrigParent.id;
			}
		}
	}

	zTreeBeforeDrop(treeId, treeNodes, targetNode, moveType) 
	{
    	let isRoot = (targetNode == null || (moveType != "inner" && !targetNode.parentTId));
    	if(isRoot)
    	 	return false;
    	
		let srcItems = treeNodes;
		if(!srcItems || srcItems.length==0)
		{
			return false;
		}

		if(!this.validateLevel(srcItems))
			return false;
		let base = srcItems[0];
		let baseParentNode = this.getParentNode(base);
		if(!this.validateFieldGroupDrag(baseParentNode))
			return false;


		let dropTarget = targetNode;
		let dropTargetParent = this.getParentNode(targetNode);
		
		
		if(!this.validateFieldGroupDrag(dropTargetParent))
			return false;
		
		
		let toType = targetNode.type;
		let toParentType = (moveType == "inner"?toType:dropTargetParent.type);
		var position = this.validateType(srcItems,toType,toParentType);
		
		if(position == "down" && moveType != "inner")
			position = "true";
		if(position == "true" && moveType == "inner")
			position = "down";
		
		if(position == "down" && !this.validateFieldGroupDrag(dropTarget))
		{
			this.adjustSrcForm(treeNodes, targetNode, moveType);
			return true;
		}
		
		if(position == "draginvalid")
		{
			return false;
		}
		
		if(!this.validateDataSourceGroup(position,srcItems,dropTarget))
		{
			return false;
		}
		
		if(position == "true")
		{
			this.adjustSrcForm(treeNodes, targetNode, moveType);
			return true;
		}
		
		if(position == "down")
		{
			this.adjustSrcForm(treeNodes, targetNode, moveType);
			return true;
		}
		
		if(position == "false")
		{
			return false;
		}
		this.adjustSrcForm(treeNodes, targetNode, moveType);
		return true;
	}

	validateDataSourceGroup(position,srcItems,dropTarget)
	{
		if(position == "false")
			return true;
		if(srcItems.length <= 0)
			return true;
		
		if(position == "down" && dropTarget.type == "DataGrid")
		{
			for(let i = 0;i<srcItems.length;i++)
			{
				var src = srcItems[i];
				var dataSource = GOTUtil.getProperty(src,"DataSource");
				if(!dataSource.hasOwnProperty("innerid"))
					return false;
			}
			
			var baseDataSourceName = GOTUtil.getPropertyValue(src,"DataSource");
			var baseDataSource = window.formModuleInstance.formDataSources.sources[baseDataSourceName];
			var targetItems = dropTarget.FormItem;
			if(targetItems.length > 0 )
				var targetItem:XML = targetItems[0];
			if(targetItem)
			{
				var targetDataSourceName = GOTUtil.getPropertyValue(targetItem,"DataSource");
				var targetDataSource = window.formModuleInstance.formDataSources.sources[targetDataSourceName];
			}
			for(let i = 0;i<srcItems.length;i++)
			{
				let src = srcItems[i];
				var tempName = GOTUtil.getPropertyValue(src,"DataSource");
				var tempDataSource = widnow.formModuleInstance.formDataSources.sources[tempName];
				if(baseDataSource.group != tempDataSource.group ||
					(targetDataSource && tempDataSource.group != targetDataSource.group)
				)
					return false;
			}
		}
		
		var targetP = this.getParentNode(dropTarget);
		var targetPP = this.getParentNode(targetP);
		if(position == "true" &&
			(
				(targetP!=null && targetP.type=="DataGrid") || 
				(targetPP!=null && targetPP.type == "DataGrid")
			)
		)
		{
			for(let i = 0;i<srcItems.length;i++)
			{
				let src = srcItems[i];
				dataSource = GOTUtil.getProperty(src,"DataSource");
				if(!dataSource.hasOwnProperty("innerid"))
					return false;
			}
			
			targetDataSourceName = GOTUtil.getPropertyValue(dropTarget,"DataSource");
			targetDataSource = window.formModuleInstance.formDataSources.sources[targetDataSourceName];
			for(let i = 0;i<srcItems.length;i++)
			{
				let src = srcItems[i];
				tempName = GOTUtil.getPropertyValue(src,"DataSource");
				tempDataSource = window.formModuleInstance.formDataSources.sources[tempName];
				if(
					targetDataSource!=null && tempDataSource.group != targetDataSource.group
				)
					return false;
			}
		}
		
		return true;
	}

	getZNodes(item)
	{
		for(let i =0;i<item.FormItem.length;i++)
		{
			let childFormItem = item.FormItem[i];
			let itemControl = FormItemUtil.getFormItemControl("ctrl_"+childFormItem.name,false);
			let _label;
			if(itemControl)
				_label = itemControl.getProperty_Label();
			if(!_label && childFormItem.type && childFormItem.type.indexOf("Editor") == -1)
				_label = childFormItem.name;
			/*var zNode={id:childFormItem.id,pId:item.id,name:_label,formItemName:childFormItem.name,
						nodeType:childFormItem.type,sourceNode:childFormItem};
			zNodes.push(zNode);*/
			childFormItem.label = _label;childFormItem.pId = item.id;
			let isDataGrid = childFormItem.type == "DataGrid";
			if(isDataGrid)
				childFormItem.open = true;
			let toolTip = "";
			if(childFormItem.hasOwnProperty("name"))
			{
				toolTip += ("name="+childFormItem.name+" ");
			}
			else if(childFormItem.hasOwnProperty("qname"))
			{
				toolTip += ("name="+childFormItem.qname+" ");
			}
			
			if(childFormItem.hasOwnProperty("id"))
			{
				toolTip += ("id="+childFormItem.id+" ");
			}
			
			var extendsPro = GOTUtil.getProperty(childFormItem,"Extends");
			if(extendsPro)
			{
				if(extendsPro.hasOwnProperty("refentityid"))
				{
					toolTip += ("tableId="+extendsPro.refentityid+" ");
					toolTip += ("tableFieldId="+extendsPro.refinnerid);
				}
			}

			childFormItem.title = toolTip;

			let result = this.getZNodes(childFormItem);

			if(result)item.open = true;
		}
		
		return item.open;
	}

	checkHasUserSetVisible(innerId)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[innerId];
			if(_properties && _properties.hasOwnProperty("visible") && (_properties.visible == false ||  _properties.visible == 'false'))
				return true;
		}
		return false;
	}

	checkHasUserSetAllowEdit(innerId)
	{
		var _parentWindow = window.parent.window;
		if(_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[innerId];
			if(_properties && _properties.hasOwnProperty("allowEdit") && (_properties.allowEdit == false || _properties.allowEdit == 'false'))
				return true;
		}
		return false;
	}
	
	onItemClick(event, treeId, treeNode, clickFlag)
	{
		if(treeNode.id != this.currentTreeNodeId)
		{
			this.currentTreeNodeId = treeNode.id;
			let itemControl = FormItemUtil.getFormItemControl("ctrl_"+treeNode.name,false);
			let stateObj = {innerId:treeNode.id};
			if(itemControl.classAlias == "FormItemDesignControl")
			{
				stateObj.label = treeNode.name;stateObj.labelEnabled = false;
				stateObj.visible = true;stateObj.visibleEnabled = false;
				stateObj.allowEdit = true;stateObj.allowEditEnabled = false;
				stateObj.hideInVisible = true;stateObj.hideInVisibleEnabled = false;
				stateObj.skipTab = false;stateObj.skipTabEnabled = false;
				stateObj.width = "";stateObj.widthEnabled = false;
				stateObj.height = "";stateObj.heightEnabled = false;
				stateObj.shortCut = "";stateObj.shortCutEnabled = false;
				stateObj.displayLength = "";stateObj.displayLengthEnabled = false;
				stateObj.lockedNum = "";stateObj.lockedNumEnabled = false;
				stateObj.layout = "";stateObj.layoutEnabled = false;
				stateObj.itemControl = itemControl;
				UserSetActions.userSetFormTreeChanged(stateObj);
				return;
			}
			stateObj.label = itemControl.getProperty_Label();stateObj.labelEnabled = true;
			if(itemControl._cmdLabel)
				stateObj.labelEnabled = false;
			stateObj.visible = itemControl.getProperty_Visible_Final();
			stateObj.visibleEnabled = true;
			if(!stateObj.visible && !this.checkHasUserSetVisible(itemControl.xml.id))
			{
				stateObj.visibleEnabled = false;
			}

			//stateObj.visible = (UserSetFormTree.flag%2==0?true:false);
			//UserSetFormTree.flag++;
			stateObj.allowEdit = itemControl.getProperty_AllowEdit_Final();
			stateObj.allowEditEnabled = true;
			if(!stateObj.allowEdit && !this.checkHasUserSetAllowEdit(itemControl.xml.id))
			{
				stateObj.allowEditEnabled = false;
			}
			stateObj.hideInVisible = itemControl.getProperty_HideInVisible();
			stateObj.hideInVisibleEnabled = true;
			stateObj.skipTab = itemControl.getProperty_SkipTab();
			stateObj.skipTabEnabled = true;
			stateObj.width = itemControl.getProperty_Width();
			stateObj.widthEnabled = true;
			stateObj.height = itemControl.getProperty_Height();
			stateObj.heightEnabled = true;
			stateObj.itemControl = itemControl;
			if(typeof(itemControl.getProperty_ShortCut) == "function")
			{
				stateObj.shortCut = itemControl.getProperty_ShortCut();
				stateObj.shortCutEnabled = true;
			}
			else
			{
				stateObj.shortCut = "";stateObj.shortCutEnabled = false;
			}
			if(typeof(itemControl.getProperty_DisplayLength) == "function")
			{
				stateObj.displayLength = itemControl.getProperty_DisplayLength();
				stateObj.displayLengthEnabled = true;
			}
			else
			{
				stateObj.displayLength = "";stateObj.displayLengthEnabled=false;
			}
			if(typeof(itemControl.getProperty_LockedNum) == "function")
			{
				stateObj.lockedNum = itemControl.getProperty_LockedNum();
				stateObj.lockedNumEnabled = true;
			}
			else
			{
				stateObj.lockedNum = "";stateObj.lockedNumEnabled = false;
			}
			if(typeof(itemControl.getProperty_Layout) == "function")
			{
				stateObj.layout = itemControl.getProperty_Layout();
				stateObj.layoutEnabled = true;
			}
			else
			{
				stateObj.layoutEnabled = false;stateObj.layout = "";
			}

			UserSetActions.userSetFormTreeChanged(stateObj);
		}
	}

	onItemDblClick(event, treeId, treeNode)
	{

	}

	
	render()
	{		
		return  <ul style={{flexGrow:100,overflow:'auto'}} id='UserSetFormTree'  ref={node => this.treeDiv = node} className="ztree"></ul>;
	}

}


// WEBPACK FOOTER //
// ./src/userformset/UserSetFormTree.js